// extracted by mini-css-extract-plugin
var _1 = "RequestBoardColumnMessage-moduleRequestBoardColumnMessage__iDaye";
var _2 = "RequestBoardColumnMessage-moduleaction__F7A8Y";
export { _1 as "RequestBoardColumnMessage", _2 as "action" }
